var render = function render(){var _vm=this,_c=_vm._self._c;return _c('spinner',{attrs:{"font-size":14,"line-bg-color":_vm.bgColor,"line-fg-color":_vm.fgColor,"line-size":_vm.lineSize,"message":_vm.message,"size":_vm.size}})
}
var staticRenderFns = []

export { render, staticRenderFns }